export function validTournamentId(value) {
  return (typeof value === 'number' || typeof value === 'string') && /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value));
}
export function bearerFetchOptions(options, token) {
  if (typeof token !== 'string' || !token.trim()) return null;
  const headers = new Headers(options?.headers);
  headers.set('Authorization', `Bearer ${token.trim()}`);
  return { ...options, headers: Object.fromEntries(headers.entries()) };
}
export function tournamentRequestUrl(base, path, tournamentId) {
  if (!validTournamentId(tournamentId)) throw new Error('Wybierz turniej, aby wyświetlić raport.');
  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set('tournamentId', String(tournamentId));
  return `${base}${pathname}?${params.toString()}`;
}
